import { createContext, useCallback, useState } from 'react';

export const SettingStateContext = React.createContext();
export const SettingDispatchContext = React.createContext();

export const SettingProvider = ({ children }: { children: null | Node }) => {
  const [setting, setSetting] = useState(null);

  return (
    <SettingStateContext.Provider value={{ setting }}>
      <SettingDispatchContext.Provider value={{ setSetting }}>
        {children}
      </SettingDispatchContext.Provider>
    </SettingStateContext.Provider>
  );
};
